import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { RecoilRoot } from "recoil";
import { ConfigProvider } from "antd";
import vi_VN from "antd/es/locale/vi_VN";

ReactDOM.render(
  <RecoilRoot>
    <ConfigProvider locale={vi_VN}>
      <App />
    </ConfigProvider>
  </RecoilRoot>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
